import React from "react";
import "./Home.css";
import yogaImage from "./assets/yoga_front.jpg";

const Home = () => {
  return (
    <div className="full-background text-center">
      <div className="container pt-5 pb-5">
        {/* Hero */}
        <h1 className="text-light">Flow State Yoga Retreats</h1>
        <p className="text-light fw-bold mb-3">YOGA | TANTRA | HOLISTIC HEALTH</p>

        {/* Clickable scrolling banner */}
        <div className="scrolling-text-wrapper my-4">
          <a href="/maldives-retreat" className="scrolling-text">
            🌴 Maldives Yoga Retreat 2026 – NOW LIVE 🧘‍♀️ Click to view
          </a>
        </div>

        {/* Main content row */}
        <div className="row align-items-center justify-content-center g-4 my-4">
          <div className="col-md-5">
            <div className="image-box">
              <img
                src={yogaImage}
                alt="Flow State Yoga Retreats - yoga practice by the ocean"
                className="styled-img shadow-lg"
              />
            </div>
          </div>

          <div className="col-md-6 text-start script-message">
            <p className="overlay-script mb-3">Let’s move, breathe, and flow together!</p>

            <p className="welcome-paragraph mb-3">
              <strong>Welcome!</strong> I offer online classes, international yoga retreats, and holistic
              wellness practices. Join me for a journey of vitality, inner transformation, freedom of
              movement, and community.
            </p>

            {/* Primary calls-to-action */}
            <div className="d-flex flex-wrap gap-2 mt-3">
              <a href="/maldives-retreat" className="btn btn-primary">
                View Maldives Retreat
              </a>
              <a href="/himalayas-retreat" className="btn btn-primary">
                View Himalayas Retreat
              </a>
            </div>
          </div>
        </div>

        {/* Simple offerings / trust section */}
        <div className="row text-light mt-5 g-4 text-start">
          <div className="col-md-4">
            <h3 className="h5">Retreats</h3>
            <p className="mb-0">
              Immersive experiences in nature with daily yoga, movement, nourishing food, and community.
            </p>
          </div>

          <div className="col-md-4">
            <h3 className="h5">Online Classes</h3>
            <p className="mb-0">
              Weekly sessions to build strength, mobility, breath, and calm — wherever you are in the world.
            </p>
          </div>

          <div className="col-md-4">
            <h3 className="h5">Holistic Health</h3>
            <p className="mb-0">
              Support for nervous system regulation, energy, and lifestyle practices that help you feel your best.
            </p>
          </div>
        </div>

        {/* Instagram footer CTA */}
        <div className="ig-footer mt-5">
          <div className="ig-footer-line" />

          <p className="ig-footer-label mb-2">Follow on Instagram</p>

          <a
            href="https://www.instagram.com/elizacikoyoga/"
            target="_blank"
            rel="noopener noreferrer"
            className="ig-icon-link"
            aria-label="Follow Eliza on Instagram"
            title="Follow on Instagram"
          >
            <i className="bi bi-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
